import {
  take,
  put,
  call,
  all,
  takeLatest,
  takeEvery,
} from 'redux-saga/effects';
import { locationActions as actions, notificationActions } from '../actions';
import { locationService } from '../services';

/* Get All Locations list Sagas */  
function* handleGetAllLocationsRequest() {
  const action = yield take(actions.getAllLocationsRequest.getType());
  let res;
  try {
    res = yield call(locationService.getAllLocations);
    if (res.isError) {
      yield put(actions.getAllLocationsError(res));
    } else {
      yield put(actions.getAllLocationsSuccess(res));
    }
  } catch (error) {
    yield put(actions.getAllLocationsError());
  }
}
/* Create Location Sagas */
function* handleCreateLocationRequest() {
  const action = yield take(actions.createLocationRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(locationService.createLocation, dataParams);
    if (res.isError) {
      yield put(actions.createLocationError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.createLocationSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.createLocationError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/* Update Location Sagas */
function* handleUpdateLocationRequest() {
  const action = yield take(actions.updateLocationRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(locationService.updateLocation, dataParams);
    if (res.isError) {
      yield put(actions.updateLocationError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.updateLocationSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.updateLocationError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}
/* Delete Location Sagas */
function* handleDeleteLocationRequest() {
  const action = yield take(actions.deleteLocationRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(locationService.deleteLocation, dataParams);
    if (res.isError) {
      yield put(actions.deleteLocationError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.deleteLocationSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.deleteLocationError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/* Get All Location Data Sagas */
function* handleGetAllLocationsDataRequest() {
  const action = yield take(actions.getAllLocationsDataRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(locationService.getAllLocationsData, dataParams);
    if (res.isError) {
      yield put(actions.getAllLocationsDataError(res));
    } else {
      yield put(actions.getAllLocationsDataSuccess(res));
    }
  } catch (error) {
    yield put(actions.getAllLocationsDataError());
  }
}

/* Get All Countries List Data Sagas */
function* handleGetAllCountriesListRequest() {
  const action = yield take(actions.getAllCountriesListRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(locationService.getAllCountriesList, dataParams);
    if (res.isError) {
      yield put(actions.getAllCountriesListError(res));
    } else {
      yield put(actions.getAllCountriesListSuccess(res));
    }
  } catch (error) {
    yield put(actions.getAllCountriesListError());
  }
}

/* Get All State Form Country List Sagas */
function* handleGetAllStateFromCountryListRequest() {
  const action = yield take(actions.getAllStateFromCountryListRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(locationService.getAllStateFromCountryList, dataParams);
    if (res.isError) {
      yield put(actions.getAllStateFromCountryListError(res));
    } else {
      yield put(actions.getAllStateFromCountryListSuccess(res));
    }
  } catch (error) {
    yield put(actions.getAllStateFromCountryListError());
  }
}

/* Get City List From State Sagas */
function* handleGetCityListFromStateRequest() {
  const action = yield take(actions.getCityListFromStateRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(locationService.getCityListFromState, dataParams);
    if (res.isError) {
      yield put(actions.getCityListFromStateError(res));
    } else {
      yield put(actions.getCityListFromStateSuccess(res));
    }
  } catch (error) {
    yield put(actions.getCityListFromStateError());
  }
}

/* Add Employee Location Sagas */
function* handleAddEmployeeLocationRequest() {
  const action = yield take(actions.addEmployeeLocationRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(locationService.addEmployeeLocation, dataParams);
    if (res.isError) {
      yield put(actions.addEmployeeLocationError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.addEmployeeLocationSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));

    }
  } catch (error) {
    yield put(actions.addEmployeeLocationError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

function* handleGetEmployeeLocationRequest() {
  const action = yield take(actions.getEmployeeLocationRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(locationService.getEmployeeLocation, dataParams);
    if (res.isError) {
      yield put(actions.getEmployeeLocationError(res));
    } else {
      yield put(actions.getEmployeeLocationSuccess(res));
    }
  } catch (error) {
    yield put(actions.getEmployeeLocationError());
  }
}

function* handleUpdateMultipleEmployeeLocationRequest() {
  const action = yield take(actions.updateMultipleEmployeeLocationRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(locationService.updateMultipleEmployeeLocation, dataParams);
    if (res.isError) {
      yield put(actions.updateMultipleEmployeeLocationError(res));
    } else {
      yield put(actions.updateMultipleEmployeeLocationSuccess(res));
    }
  } catch (error) {
    yield put(actions.updateMultipleEmployeeLocationError());
  }
}

function* handleGetAllCityRequest() {
  const action = yield take(actions.getAllCityRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(locationService.getAllCity, dataParams);
    if (res.isError) {
      yield put(actions.getAllCityError(res));
    } else {
      yield put(actions.getAllCitySuccess(res));
    }
  } catch (error) {
    yield put(actions.getAllCityError());
  }
}

function* handleGetAllCityFromCountryRequest() {
  const action = yield take(actions.getAllCityFromCountryRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(locationService.getAllCityFromCountry, dataParams);
    if (res.isError) {
      yield put(actions.getAllCityFromCountryError(res));
    } else {
      yield put(actions.getAllCityFromCountrySuccess(res));
    }
  } catch (error) {
    yield put(actions.getAllCityFromCountryError());
  }
}

function* handleGetLocationByLetLogRequest() {
  const action = yield take(actions.getLocationByLetLogRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(locationService.getLocationByLetLog, dataParams);
    if (res.isError) {
      yield put(actions.getLocationByLetLogError(res));
    } else {
      yield put(actions.getLocationByLetLogSuccess(res));
    }
  } catch (error) {
    yield put(actions.getLocationByLetLogError());
  }
}

/* -----------Watchers------------- */
function* handleGetAllLocationsWatcher() {
  yield takeEvery(
    actions.getAllLocationsRequest,
    handleGetAllLocationsRequest,
  );
}

function* handleCreateLocationWatcher() {
  yield takeEvery(
    actions.createLocationRequest,
    handleCreateLocationRequest,
  );
}

function* handleUpdateLocationWatcher() {
  yield takeEvery(
    actions.updateLocationRequest,
    handleUpdateLocationRequest,
  );
}

function* handleDeleteLocationWatcher() {
  yield takeEvery(
    actions.deleteLocationRequest,
    handleDeleteLocationRequest,
  );
}

function* handleGetAllLocationsDataWatcher() {
  yield takeEvery(
    actions.getAllLocationsDataRequest,
    handleGetAllLocationsDataRequest,
  );
}

function* handleGetAllCountriesListWatcher() {
  yield takeEvery(
    actions.getAllCountriesListRequest,
    handleGetAllCountriesListRequest,
  );
}

function* handleGetAllStateFromCountryListWatcher() {
  yield takeEvery(
    actions.getAllStateFromCountryListRequest,
    handleGetAllStateFromCountryListRequest,
  );
}


function* handleGetCityListFromStateWatcher() {
  yield takeEvery(
    actions.getCityListFromStateRequest,
    handleGetCityListFromStateRequest,
  );
}


function* handleAddEmployeeLocationWatcher() {
  yield takeEvery(
    actions.addEmployeeLocationRequest,
    handleAddEmployeeLocationRequest,
  );
}


function* handleGetEmployeeLocationWatcher() {
  yield takeEvery(
    actions.getEmployeeLocationRequest,
    handleGetEmployeeLocationRequest,
  );
}

function* handleUpdateMultipleEmployeeLocationWatcher() {
  yield takeEvery(
    actions.updateMultipleEmployeeLocationRequest,
    handleUpdateMultipleEmployeeLocationRequest,
  );
}

function* handleGetAllCityWatcher() {
  yield takeEvery(
    actions.getAllCityRequest,
    handleGetAllCityRequest,
  );
}

function* handleGetAllCityFromCountryWatcher() {
  yield takeEvery(
    actions.getAllCityFromCountryRequest,
    handleGetAllCityFromCountryRequest,
  );
}

function* handleGetLocationByLetLogWatcher() {
  yield takeEvery(
    actions.getLocationByLetLogRequest,
    handleGetLocationByLetLogRequest,
  );
}

function* rootLocationSaga() {
  yield all([
    handleGetAllLocationsRequest(),
    handleGetAllLocationsWatcher(),

    handleCreateLocationRequest(),
    handleCreateLocationWatcher(),

    handleUpdateLocationRequest(),
    handleUpdateLocationWatcher(),

    handleDeleteLocationRequest(),
    handleDeleteLocationWatcher(),

    handleGetAllLocationsDataRequest(),
    handleGetAllLocationsDataWatcher(),
    
    handleGetAllCountriesListRequest(),
    handleGetAllCountriesListWatcher(),

    handleGetAllStateFromCountryListRequest(),
    handleGetAllStateFromCountryListWatcher(),

    handleGetCityListFromStateRequest(),
    handleGetCityListFromStateWatcher(),

    handleAddEmployeeLocationRequest(),
    handleAddEmployeeLocationWatcher(),

    handleGetEmployeeLocationRequest(),
    handleGetEmployeeLocationWatcher(),

    handleUpdateMultipleEmployeeLocationRequest(),
    handleUpdateMultipleEmployeeLocationWatcher(),

    handleGetAllCityRequest(),
    handleGetAllCityWatcher(),

    handleGetAllCityFromCountryRequest(),
    handleGetAllCityFromCountryWatcher(),
    
    handleGetLocationByLetLogRequest(),
    handleGetLocationByLetLogWatcher(),
  ]);
}

export default rootLocationSaga;
